<div class="content">
  <div class="row chart-wrapper" *ngIf="single">
    <div class="col-12">
      <ngx-charts-pie-chart
        [view]="[228, 228]"
        [scheme]="colorScheme"
        [results]="single"
        [gradient]="true"
        [legend]="false"
        [doughnut]="true"
        [labels]="false">
      </ngx-charts-pie-chart>
    </div>
  </div>
</div>
